import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
// import Page from "react-page-loading";
import  PageHeader          from './PageHeader';
// import  CtaSection          from './CtaSection';
// import  { HomePageS2 }      from './HomePageS2';
// import  { HomePageS3 }      from './HomePageS3';
// import  { HomePageS4 }      from './HomePageS4';
// import  { FooterSection }   from './FooterSection';
// import NavBarMultiPage      from "../components/common/NavBarMultiPage";
// import PageHeader           from "../components/common/PageHeader";
import HomeSlides      from "../components/versionSeven/HomeSlides";
import RepairBoxes     from "../components/versionSeven/RepairBoxes";
import About     from "../components/versionSeven/About";
// import Services     from "../components/versionSeven/Services";
// import Team     from "../components/versionSeven/Team";
import Feedback     from "../components/versionSeven/Feedback";
import Footer     from "../components/versionSeven/Footer";
import ScrollUpBtn from "../components/common/ScrollUpBtn";


// CtaSection is the first section ; this is the Call To Action section
// HomePageS2 is section 2 - What is it ?
// HomePageS3 is section 3 - How it works
// HomePageS4 is section 4 - Welcome Feedback Form
export class HomePage extends React.Component {
// export const HomePage  = (props) =>  (  // use destructing to obtain function prop
    isLoaded = false;

    componentDidMount()  {
        this.isLoaded = true;
    }

    componentWillUnmount()  {
        this.isLoaded = false;
    }

    render() {
        
        return (
            
            <div>
                {/* <Page loader={"bar"} color={"#2980B7"} size={9}>  */}
                    <Helmet>
                        <title>Pitch In Club - Simple Event Planning </title>
                        <meta name="description" content="The Simple Event Planning / Tracking   Tool that helps with Organizing events and encourages people to Pitch In and Help out" />
                        <meta name="keywords"  content="cookout,minimal stress,chip in,pitch in,sign ups,dashboard,upcoming events, 
                            potluck,get help,family reunion,volunteer effort,birthday party,BBQ,Barbeque,Housewarming,Cocktail Party"   />
0                    </Helmet>
                    {/*
                    <PageHeader />
                    */ }
                    <PageHeader pageName="home" />  
                    <HomeSlides />
                    <RepairBoxes />
                    <About />
                    {/* <Services /> 
                    <Team />
                */}
                    <Feedback />
                {/*  
                    <CtaSection />
                    <HomePageS2 />
                    <HomePageS3 />
                    <HomePageS4 />
                    <FooterSection />
                */}
                    <Footer />
                    <ScrollUpBtn /> 
               {/* </Page>   */}
            </div>
        )
    }
};
   

// const mapDispatchToProps = (dispatch) => ({
//     startLogin: () => dispatch(startLogin())
// })

// export default connect(undefined, mapDispatchToProps)(LoginPage);
export default connect()(HomePage);




// WEBPACK FOOTER //
// ./src/components/HomePage.js